module.exports = {
    LoadTargets: "CAUDITDATA.TARGETLOAD",
    LoadedTargets: "CAUDITDATA.TARGETLOADED",
    LoadTargetsErrored: "CAUDITDATA.TARGETLOADERRORED",
    TargetSelected: "CAUDITDATA.TARGETSELECTED",
};


// WEBPACK FOOTER //
// ./src/actions/metadata/CauditActions.js